import { render, staticRenderFns } from "./grantDialog.vue?vue&type=template&id=db95c29e&scoped=true"
import script from "./grantDialog.vue?vue&type=script&lang=js"
export * from "./grantDialog.vue?vue&type=script&lang=js"
import style0 from "./grantDialog.vue?vue&type=style&index=0&id=db95c29e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db95c29e",
  null
  
)

export default component.exports